const settings = {
  sidebarWidth: 280,
  sidebarClose: 95,
  sidebarPanelClose: 85,
  borderRadius: 12,
  blockBorderRadius: '.875rem',

  wrapper: 88,
  wrapperStatic: 71,
  productsWrapper: 73
}

export default settings
